module.exports = __webpack_public_path__ + "media/siren.63318fee.mp3";